import React, { Component } from 'react';

import pckg from '../package.json';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import FeedPage from './pages/FeedPage';
import UserProfilePage from './pages/UserProfilePage';
import MoleculeDetailPage from './pages/MoleculeDetailsPage';
import NotFoundPage from './pages/NotFoundPage';


class App extends Component {

  render() {
    const { routerPrefix } = pckg;
    return (
      <Router basename={routerPrefix}>
        <div className="root-react">
          <Switch>
            <Route exact path="/" component={FeedPage} />
            <Route path="/profile" component={UserProfilePage} />
            <Route path="/molecule/:fp" component={MoleculeDetailPage} />
            <Route path="*" component={NotFoundPage}/>
          </Switch>
        </div>
      </Router>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js